import OfferItem from '../OfferItem/offer-item';

export default OfferItem;